import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ListDiffAttI, TrackChangeDetail} from '../../../shared/types/track-changes/track-changes';
import * as _ from 'lodash';

@Component({
  selector: 'wsd-list-diff',
  templateUrl: './list-diff.component.html',
  styleUrls: ['./list-diff.component.css']
})
export class ListDiffComponent implements OnInit {

  @Input()
  update: boolean;

  @Input()
  data: TrackChangeDetail;

  @Input()
  listAttribute: any;

  @Input()
  headerAttribute: string;

  @Input()
  attributesDisplayed: Array<ListDiffAttI>;

  @Input()
  subsectionHeaderArr: Array<string> = [];


  complexAttributesDisplayed: Array<ListDiffAttI>;

  @Output()
  onVisibilityChange: EventEmitter<boolean> = new EventEmitter();

  oldDataList: Array<any>;
  newDataList: Array<any>;

  oldDataListFiltered: Array<any>;
  newDataListFiltered: Array<any>;

  constructor() {
  }

  ngOnInit() {
    this.complexAttributesDisplayed = this.attributesDisplayed.filter(a => a.attributePath.match('.'));
    if (this.data !== undefined) {
      this.newDataList = this.extractData(this.data.newData);
      this.oldDataList = this.extractData(this.data.oldData);
      setTimeout(() => {
        if (this.update) {
          this.filterOutDiff();
          if (this.newDataListFiltered.length > 0 || this.oldDataListFiltered.length > 0) {
            this.onVisibilityChange.emit(true);
          }

        } else {
          if ((this.newDataList !== null && this.newDataList.length > 0) || (this.oldDataList !== null && this.oldDataList.length > 0)) {
            this.onVisibilityChange.emit(true);
          }
        }
      }, 200);
    }
  }

  getSubsectionHeader(obj): string {
    return this.subsectionHeaderArr.map(a => _.get(obj, a)).join(' ');

  }

  extractData(data: any): Array<any> {
    return data !== null && data.hasOwnProperty(this.listAttribute) ? data[this.listAttribute] : null;
  }

  getHeaderAttribute(obj: any): string {
    return _.get(obj, this.headerAttribute);
  }

  anyNotFiltered(): any[] {
    if (this.oldDataList !== null && this.oldDataList !== undefined) {
      return this.oldDataList;
    } else {
      return this.newDataList;
    }
  }

  getFilteredObject(obj: any): Array<ListDiffAttI> {
    const arr: ListDiffAttI[] = [];
    for (const x of Object.keys(obj)) {
      const foundAttribute = this.attributesDisplayed.find(a => a.attributePath === x);
      if (foundAttribute !== undefined) {
        foundAttribute.attributeValue = _.get(obj, foundAttribute.attributePath);
        arr.push(foundAttribute);
      } else {
        const specialAtt = this.complexAttributesDisplayed.find(a => a.attributePath.includes(x + '.'));
        if (specialAtt !== undefined) {
          // this is bit lame because we take first attribute matched in special attributes(nested ones)
          // and this can be problem if we want two attributes from one nested object
          specialAtt.attributeValue = _.get(obj, specialAtt.attributePath);
          arr.push(specialAtt);
        }
      }
    }
    return arr.filter(a => a.attributeValue !== '' && a.attributeValue !== undefined && a.attributeValue !== null);
  }

  filterOutDiff() {
    this.oldDataListFiltered = this.oldDataList.filter(a => {
      const newSimilar = this.newDataList.find(n => n.id === a.id);
      if (newSimilar === undefined) {
        return true;
      }
      for (const x of Object.keys(a)) {
        if ((typeof a[x]) === 'object') {
          if (this.headerAttribute.includes('.')) {
            const result =  _.get(a, this.headerAttribute) !== _.get(newSimilar, this.headerAttribute);
            if (result) {return true; }
          }
        } else if (a[x] !== newSimilar[x]) {
          return true;
        }
      }
      return false;
    });
    this.newDataListFiltered = this.newDataList.filter(a => {
      const newSimilar = this.oldDataList.find(n => n.id === a.id);
      if (newSimilar === undefined) {
        return true;
      }
      for (const x of Object.keys(a)) {
        if ((typeof a[x]) === 'object') {
         if (this.headerAttribute.includes('.')) {
           const result =  _.get(a, this.headerAttribute) !== _.get(newSimilar, this.headerAttribute);
           if (result) {return true; }
         }
        } else if (a[x] !== newSimilar[x]) {
          return true;
        }
      }
      return false;
    });
    // this part sorts update to be at top of lists for better UI
    let tempArr = [];
    for (const a of this.oldDataListFiltered) {
      const res = this.newDataListFiltered.find(x => x.id === a.id);
      if (res !== undefined) {
        tempArr.push(a);
      }
    }
    for (const a of this.oldDataListFiltered) {
      const res = tempArr.find(x => x.id === a.id);
      if (res === undefined) {
        tempArr.push(a);
      }
    }
    this.oldDataListFiltered = tempArr;
    tempArr = [];
    for (const a of this.oldDataListFiltered) {
      const res = this.newDataListFiltered.find(x => x.id === a.id);
      if (res !== undefined) {
        tempArr.push(res);
      }
    }
    for (const a of this.newDataListFiltered) {
      const res = tempArr.find(x => x.id === a.id);
      if (res === undefined) {
        tempArr.push(a);
      }
    }
    this.newDataListFiltered = tempArr;
  }
}
